export default __webpack_public_path__ + "static/media/4.da1da8a4.png";